<template>
    <div class="pay full">
        <!-- 导航 -->
        <tabbar :msg="msg" :goBack="goBack"></tabbar>
        <div class="staus1" v-show="status == 0" style="height: 94%; position: relative;width: 100%;">
            <div class="orderNo">
                <p>订单号：<span v-text="snCode"></span> </p>
            </div>
            <div class="snCode">
                <p>sn查询码：<span v-text="snCode"></span> </p>
            </div>
            <!-- 订单商品 -->
            <div class="item" v-for="(item, idx) in orderGoodsList" :key="idx">
                <div class="goods">
                    <img :src="item.goodsImgurl" alt="">
                    <div class="text">
                        <h3 v-text="item.goodsName"></h3>
                        <span v-text="'类型：' + item.goodsClassName"></span>
                        <span v-text="'数量：' + item.goodsQty + '(盒)'" style="margin-top: 5px;"></span>
                        <!-- <p v-if="item.factPrice && item.factPrice.indexOf('.') < 0" v-text="'￥ ' + item.factPrice"></p> -->
                        <p>￥<span v-text="item.factPrice.split('.')[0]"></span>{{item.factPrice.split('.')[1] ? '.' + item.factPrice.split('.')[1]: ''}}</p>
                    </div>
                </div>

                <div class="money">
                    <p class="p1">
                        <span>商品总计</span>
                        <span v-text="'￥' + curOrder.factPrice"></span>
                    </p>
                    <p class="p2">
                        <span>运费</span>
                        <span v-text="'￥' + (curOrder.sendPrice && curOrder.sendPrice !== 'null' ? curOrder.sendPrice : 0)"></span>
                    </p>
                </div>
            </div>

            <div class="allPlace">
                <span class="sp1">应付金额：</span>
                <span class="sp2">￥<em v-text="(curOrder.factPrice + '').split('.')[0]"></em>{{(curOrder.factPrice + '').split('.')[1] ? '.' + (curOrder.factPrice + '').split('.')[1] : ''}}</span>
                
            </div>

            
            <div class="payTitle text_size14">
                <span></span>支付方式
            </div>

            <div class="payBtn">
                <div class="i" v-for="(item,idx) in payBtns" :key="idx" @click="checkPay(item, idx)">
                    <div class="l">
                        <img :src="item.img" alt="">
                        <span v-text="item.text"></span>
                    </div>

                    <div class="r">
                        <div v-show="actIdx == idx"></div>
                    </div>
                </div> 
            </div>

            <div class="goPay" @click="goPay">立即支付</div>
            <!--<div class="goPay" @click="goPay">立即支付</div>-->
            <!-- <input type="text" v-model="text" id="copy"> -->
        </div>
        <div class="staus2" v-show="status == 1" style="height: 100%; position: relative;width: 100%;">
            <pay_success :orderNo="orderNo"></pay_success>
        </div>
        <div class="staus3" v-show="status == -1" style="height: 100%; position: relative;width: 100%;">
            <pay_fail></pay_fail>
        </div>


    </div>
</template>
<script>
    import api from '@/utils/js/api';
    import _AP from '@/utils/js/ap';
    import './pay.scss';
    import pay_success from '@/components/pay_success/pay_success.vue';
    import pay_fail from '@/components/pay_fail/pay_fail.vue';


    export default {
        data(){
            return {
                status: 0,
                goBack: -1,
                text: '',
                msg: '选择支付方式',
                orderNo: '',
                userInfo: '',
                openid: '',
                // 当前订单
                curOrder: '',
                // 当前订单商品
                orderGoodsList: '',
                actIdx: 0,
                payBtns:[
                    {
                        img: this.$store.state.api.imgUrl + 'wx.png',
                        text: '微信',
                        event: 'wxPay'
                    },
                    /*{
                        img: this.$store.state.api.imgUrl + 'zfb.png',
                        text: '支付宝',
                        event: 'aliPay'
                    },*/
                ]
            }
        },
        components: {
            pay_success,
            pay_fail,
        },
        created(){
            // return;
            this.params = JSON.stringify(this.$route.query) != '{}' ? this.$route.query : this.$route.params;
            console.log('查询订单号', this.params,this.$store.state);
            // 支付宝支付成功
            // if(this.params.status) return this.status = this.params.status;
            this.orderNo = this.params.orderNo;
            this.goBack = this.params.goBack * 1 || -1;
            this.$store.commit('getUserInfo');
            this.userInfo = this.$store.state.userInfo;
            this.openid = this.$store.state.openid;
            if(!this.orderNo) return;
            this.queryOrderInfo();
        },
        beforeMount(){
            // console.log(this.$util.sort_ASCII);
        },
        methods: {
            //查询订单信息
            queryOrderInfo() {
                this.$http({
                    url: api.queryOrderInfo,
                    method: 'post',
                    data:{
                        orderNo: this.orderNo,
                        orderUserId: this.userInfo.userId
                    }
                }).then(res=>{
                    if(res.success){
                        this.curOrder = res.data;
                        this.orderGoodsList = res.data.orderGoodsList;
                    }else{
                        this.$toast(res.message);
                    }
                })
            },
            //选择支付方式
            checkPay(item, idx){
                this.actIdx = idx;
            },
            //立即支付
            goPay(){
                console.log(this.payBtns[this.actIdx].text)
                this[this.payBtns[this.actIdx].event]();
            },
            // 微信支付
            wxPay(){
                if (typeof WeixinJSBridge == "undefined"){
                    if( document.addEventListener ){
                        document.addEventListener('WeixinJSBridgeReady', this.orderPay, false);
                    }else if (document.attachEvent){
                        document.attachEvent('WeixinJSBridgeReady', this.orderPay); 
                        document.attachEvent('onWeixinJSBridgeReady', this.orderPay);
                    }
                }else{
                    this.orderPay();
                }
            },
            // 统一下单
            orderPay(){
                var openId = this.openid ? this.RSA(this.openid) : this.RSA(this.userInfo.publicOpenid);
                this.$http({
                    url: api.orderPay,
                    method: 'post',
                    data: {
                        orderId: this.orderId,
                        openId: openId,
                        orderNo: this.orderNo,
                        //orderSn: this.orderSn,
                        source: this.$store.state.source
                    }
                }).then(res=>{
                    if(res.success){
                        this.onBridgeReady(res.data);
                    }else{
                        this.$toast(res.message != 'ok' ? res.message : '支付失败');
                    }
                })
            },
            // RSA加密
            RSA(str){
                if(!str) return;
                var Encrypt = new JSEncrypt();
                Encrypt.setPublicKey(api.RES_PUBLIC_KEY);
                console.log(Encrypt.encrypt(str).toLocaleUpperCase());
                return Encrypt.encrypt(str).toLocaleUpperCase();
            },
            //调起支付
            onBridgeReady(data){
                var that = this;
                var _data = {
                    "appId": data.appId,     //公众号名称，由商户传入     
                    "timeStamp": data.timeStamp,         //时间戳，自1970年以来的秒数     
                    "nonceStr": data.nonceStr, //随机串     
                    "package": data.packageStr,  
                    "signType": data.signType,         //微信签名方式：     
                    "paySign": data.paySign //微信签名 
                }

                // alert(JSON.stringify(_data));

                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', _data,
                    function(res){
                        console.log('支付结果',res);
                        // alert(JSON.stringify(res))
                        that.msg = '订单完成';
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){
                            that.$toast('支付成功')
                            setTimeout(()=>{
                                that.status = 1;
                            },1200)
                        }else{
                            that.$toast('支付失败')
                            setTimeout(()=>{
                                that.status = -1;
                            },1200)
                        }
                    }
                );
            },
            //支付宝支付
           /* aliPay(){
                this.$http({
                    url: api.orderAliPay,
                    method: 'post',
                    data: {
                        orderNo: this.orderNo,
                    }
                }).then(res=>{
                    if(res.success){
                        if(this.$store.state.is_wx){
                            const div = document.createElement('div');
                            div.innerHTML = res.data;
                            document.body.appendChild(div);
                            // document.forms[0].submit();
                            var queryParam = '';
                            Array.prototype.slice
                                .call(
                                document
                                .querySelectorAll("input[type=hidden]"))
                                .forEach(
                                function(ele) {
                                    queryParam += ele.name
                                        + "="
                                        + encodeURIComponent(ele.value)
                                        + '&';
                                });
                            let url = document.forms[0].action+ '&' + queryParam
                            console.log('url',url)
                            _AP.pay(url)
                        }
                    }else{
                        this.$toast(res.message);
                    }
                })
                
            }*/
        }
        
    }
</script>